export const COMMUNITY_AMBASSADOR_FEATURE_FLAG = 'CommunityAmbassadors';
export const TRACK_ATTENDANCE_BULK_UPLOAD_SINGLE_SHIFT = 'TrackAttendanceBulkUploadSingleShift';
export const TRACK_ATTENDANCE_BULK_UPLOAD_MULTI_SHIFT = 'TrackAttendanceBulkUploadMultiShift';
export const EVENT_CREATION = 'EventCreation';
export const MANAGE_SIGNUPS_ON_SHIFT_LEVEL = 'ManageSignupsOnShiftLevel';
export const MANAGE_SIGNUPS_ON_EVENT_LEVEL = 'ManageSignupsOnEventLevel';

// constants used for website analytics metrics key
export const UNDER_SCORE = '_';
export const UNAUTHORIZED = 'unauthorizedUserAction';
export const COORDINATOR_EVENT_SHIFTS_TABLE = 'coordinatorEventShiftsTable';
export const EVENT_DETAIL_PAGE = 'eventDetailPage';
export const COORDINATOR_ACTIVITY_PAGE = 'coordinatorActivityPage';

export const COORDINATOR_EVENT_SHIFTS_TABLE_FROM_EVENT_DETAIL_PAGE =
  EVENT_DETAIL_PAGE + UNDER_SCORE + COORDINATOR_EVENT_SHIFTS_TABLE;
export const COORDINATOR_EVENT_SHIFTS_TABLE_FROM_COORDINATOR_ACTIVITY_PAGE =
  COORDINATOR_ACTIVITY_PAGE + UNDER_SCORE + COORDINATOR_EVENT_SHIFTS_TABLE;

export const COORDINATOR_EVENT_SHIFTS_LIST = 'coordinatorEventShiftsList';
export const ACTIVITY_PAGE = 'activityPage';
export const SIGN_UP_ACTION = 'signUpAction';
export const SEARCH_RESULTS = 'eventSearch';
export const TRACK_ATTENDANCE_ACTION = 'trackAttendanceAction';
export const TRACK_UNLISTED_EVENT_ACTION = 'trackUnlistedEventAction';

export const SIGN_UP_ACTION_FROM_COORDINATOR_EVENT_SHIFTS_TABLE_FROM_EVENT_DETAIL_PAGE =
  COORDINATOR_EVENT_SHIFTS_TABLE_FROM_EVENT_DETAIL_PAGE + UNDER_SCORE + SIGN_UP_ACTION;
export const SIGN_UP_ACTION_FROM_COORDINATOR_EVENT_SHIFTS_TABLE_FROM_COORDINATOR_ACTIVITY_PAGE =
  COORDINATOR_EVENT_SHIFTS_TABLE_FROM_COORDINATOR_ACTIVITY_PAGE + UNDER_SCORE + SIGN_UP_ACTION;
export const TRACK_ATTENDANCE_ACTION_FROM_COORDINATOR_EVENT_SHIFTS_TABLE_FROM_EVENT_DETAIL_PAGE =
  COORDINATOR_EVENT_SHIFTS_TABLE_FROM_EVENT_DETAIL_PAGE + UNDER_SCORE + TRACK_ATTENDANCE_ACTION;
export const TRACK_ATTENDANCE_FROM_COORDINATOR_EVENT_SHIFTS_TABLE_FROM_COORDINATOR_ACTIVITY_PAGE =
  COORDINATOR_EVENT_SHIFTS_TABLE_FROM_COORDINATOR_ACTIVITY_PAGE +
  UNDER_SCORE +
  TRACK_ATTENDANCE_ACTION;

export const TRACK_UNLISTED_EVENT_FROM_COORDINATOR_ACTIVITY_PAGE =
  COORDINATOR_ACTIVITY_PAGE + UNDER_SCORE + TRACK_UNLISTED_EVENT_ACTION;

// Signup management analytics
export const SIGNUP_MANAGEMENT = 'signupManagement';
export const SINGLE_SHIFT_VIEW = 'singleShiftView';
export const SIGNUP_MANAGEMENT_PAGE_VIEW = SIGNUP_MANAGEMENT + '_pageView';

// Signup management for a single shift
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_PAGE_VIEW =
  SIGNUP_MANAGEMENT_PAGE_VIEW + '_' + SINGLE_SHIFT_VIEW;
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT = SIGNUP_MANAGEMENT + '_' + SINGLE_SHIFT_VIEW;
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_SIGNUP_AMAZONIANS_BUTTON =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_signupAmazoniansButton';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_CANCEL_SIGNUP =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_cancelSignup';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_SEARCH_PEOPLE_FILTER =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_searchPeopleFilter';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_ADD_SIGNUP_FROM_SEARCH =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_addSignupFromSearch';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_BULK_UPLOAD_VALIDATE_SIGNUPS =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_bulkUploadValidateSignups';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_BULK_UPLOAD_VALIDATION_SUCCESS_COUNT =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_bulkUploadValidationSuccessCount';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_BULK_UPLOAD_VALIDATION_ERRORS_COUNT =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_bulkUploadValidationErrorsCount';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_BULK_UPLOAD_VALIDATION_SKIPPED_COUNT =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_bulkUploadValidationSkippedCount';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_BULK_UPLOAD_ADD_SIGNUPS =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_bulkUploadAddSignups';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_DOWNLOAD_SIGNUP_LIST =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_downloadButton';
export const SIGNUP_MANAGEMENT_SINGLE_SHIFT_SIGNUP_THROUGH_GIVE_HUB_LINK =
  SIGNUP_MANAGEMENT_SINGLE_SHIFT + '_manageSignupsFromGiveHub';
//  Ambassadors
export const AMBASSADOR_EXTERNAL_PLAN_EVENT_LINK =
  'https://w.amazon.com/bin/view/AmazonInTheCommunity/Volunteering/PlanAnEvent/';
